


















































import { Vue, Component } from 'vue-property-decorator';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { DaTeacherService } from '../../biz/remote/DaTeacherService';
import { TeacherInfoInputDTO } from '../../../src_server/entity/dto/TeacherInfoInputDTO';
import { MessageDialog } from '../../utils/MessageDialog';
import { DaLessonsService } from '../../biz/remote/DaLessonsService';
import { Session } from '../../utils/Session';
import { dayjs, DT_FORMAT_JA, DW_FORMAT_JA, D_FORMAT_INPUT, T_FORMAT } from '../../../src_server/common/momentExtends';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import { LessonStates } from '../../../src_server/entity/master/LessonStates';

@Component({
  filters: {
    dateFormat: (date: Date) => {
      return dayjs(date).format(DW_FORMAT_JA);
    },
  },
  components: { CommonDialog, VueTimepicker },
})
export default class StudentLessonRequestDialog extends Vue {
  private dto = new TeacherInfoInputDTO();
  private teacher_user_id = '';
  private shift_table_id = 0;
  private requestDateTime: { date: Date; start_time_string: string; end_time_string: string }[] = [];

  private get title() {
    return `${this.dto.teacher?.nickname} 詳細`;
  }

  private get image() {
    return this.dto.teacher?.img_path;
  }
  private get schoolYear() {
    return this.dto.teacher?.target_school_year;
  }
  private get weekDay() {
    return this.dto.teacher?.work_day_of_week;
  }
  private get contents() {
    return this.dto.da_teacher?.contents;
  }

  private get isFlexTime() {
    return this.dto.da_teacher.is_time_flex;
  }

  public async show(teacher_user_id: string, shift_table_id: number, start_dt: Date, end_dt: Date) {
    this.requestDateTime = [];
    this.teacher_user_id = teacher_user_id;
    this.shift_table_id = shift_table_id;
    this.requestDateTime.push({ date: dayjs(start_dt).toDate(), start_time_string: dayjs(start_dt).format(T_FORMAT), end_time_string: dayjs(end_dt).format(T_FORMAT) });

    const tbiz = new DaTeacherService();
    const response = await tbiz.getTeacher(teacher_user_id);

    this.dto = response.data;
    (this.$refs['student-lesson-request-dialog'] as CommonDialog).show();
  }

  sendRequest() {
    this.$emit('on-send-request');
    this.close();
  }

  public close() {
    (this.$refs['student-lesson-request-dialog'] as CommonDialog).hide();
  }

  /**
   * 予約依頼を先生に送信
   */
  async sendToTeacher() {
    if (!Session.isProfielComplete()) {
      MessageDialog.alertModal(`プロフィールを100%入力すると予約が実施できます。`);
      return;
    }

    let hasDuplicate = false;
    const biz = new DaLessonsService();
    let resultMessages: string[] = [];

    const requestPromises = this.requestDateTime.map(async (d, index: number) => {
      if (!this.dto?.userAuth?.user_id) {
        await MessageDialog.systemError('先生情報', '予約依頼送信時', this.dto?.userAuth?.user_id);
        return;
      }

      const day_of_week = false;
      const date_string = dayjs(d.date).format(D_FORMAT_INPUT);
      const start_dt = dayjs(date_string + d.start_time_string).toDate();
      const end_dt = dayjs(date_string + d.end_time_string).toDate();
      const result = await biz.reservation(Session.getSessionUserId(), this.teacher_user_id, start_dt, end_dt, this.shift_table_id, day_of_week);

      if (result.hasError) {
        await MessageDialog.alert(`${result.status}, ${result.errorDescription}, ${result.errorExpandedData}`);
        return; // continue next
      }

      const reservationResult = result.data;
      console.log(reservationResult);
      // reservationResult.reservatedLessons;
      // if (reservationResult.reservatedLessons.length > 0) {
      //   this.cancelRequest(this.requestDateTime.findIndex((p) => p.original_dt === d.original_dt));
      // }
      if (reservationResult.reservatedLessons.length > 0) {
        resultMessages = reservationResult.reservatedLessons.map((l) => {
          return `${dayjs(l.start_dt).format(DT_FORMAT_JA)}の${LessonStates.getDaState(l.reservation_state || '')}`;
        });
      }

      if (reservationResult.duplicateLessons.length > 0) {
        this.$emit('on-duplicate', { index: index, is_duplicate: true });
        if (!hasDuplicate) {
          hasDuplicate = true;
        }
      }
    });

    await Promise.all(requestPromises);

    if (hasDuplicate) {
      await MessageDialog.alert(`予約できない時間帯がありました。確認ください。`);
    } else {
      await MessageDialog.alert(resultMessages.join('<br>'));
      this.close();
    }
  }
}
